<template>
  <div>
    <div class="top_img">
      <img :src="picpreFix + orderDetail.mainPic" alt="" />
    </div>
    <div class="container">
      <div class="museumInformation">
        <div class="museumName">{{ orderDetail.name }}</div>
        <div class="museumIntroduce">
          开放时间：{{ orderDetail.openingInformation }}
        </div>
      </div>

      <!-- 预约时间 -->
      <div class="timeChoose">
        <van-cell is-link @click="showPopup"
          ><span class="travelDate_text">预约日期</span>
          <span class="travelDate_text2">{{ currentDate }}</span></van-cell
        >
        <van-cell is-link @click="showSession"
          ><span class="sessionTime_text">到馆时间</span>
          <span class="sessionTime_text2">{{ sessionTime }}</span></van-cell
        >
        <van-cell
          ><div class="shengyu">剩余名额：{{ perSonNum }}</div></van-cell
        >
      </div>

      <!-- 添加游客 -->
      <div
        class="addVisitors"
        @click="addVisitor"
        v-if="!$store.state.perSon.length"
      >
        <van-cell
          ><span class="add_one">添加游客</span
          ><span class="add"
            ><img
              src="data:image/png;base64,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"
              alt="" /></span
        ></van-cell>
      </div>

      <!-- 选择游客 -->
      <div class="chooseVisitors" v-if="$store.state.perSon.length">
        <div class="choose_title">选择游客</div>
        <div class="choose_person">
          <div
            class="perSon_information"
            :class="{ selected: item.isSelected }"
            v-for="(item, index) in $store.state.perSon"
            :key="index"
            @click="checked(item, index)"
          >
            {{ item.name }}
          </div>
          <div class="perSon_information2">
            <span class="chooseImg"
              ><img
                src="data:image/png;base64,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"
                alt=""
            /></span>
            <span class="addText" @click="addVisitor">新增</span>
          </div>
        </div>

        <van-cell is-link v-for="(item, index) in selected" :key="index">
          <div class="perSon_Detail">
            <div class="perSon_delete" @click="deletePerson(index)">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAaVBMVEUAAAD/QGD/QGr/QGD/TmT/Smr/TGj/SWT/SWb/R2P/Smv/SWn/SWj/TGb/S2n/Smj/TWj/TWr/TGn/TGj/TGn/TWn/TWr/TGr/TWr/TGr/TWr/TWn/TGr/TGn/TWn/TWr/TWr/TGn/TWpeGcZbAAAAInRSTlMACAwQFxgbHCMkNzg7PF9gZ2dof6+zt8PLz9ff5+vr7/P3D+WWWAAAAPFJREFUSMftVV0TgiAQRIzMPjC1qwBL3P//I3tqJi7EYaanat/uZheP89gT4o9MrI7kJgSYHB1XM3TZM/ITvpcx/toA1NRFmC3qhgCzfudXA+wu/umDxVC91WNwKefuVl5geFU9bDnfjdKiDzNqwi7VvwO8ChItKN1xQsviJi1o2IkOdVpQwwXxhCItkPBBDCyNDWN8l6C9vU72qBcFY/gW7p8XtPfMkn7ox2WPd/YDOkOnBRqnIO6WTaDjNrNN8ffcZrKNbNEqrzJmxjNV7S0GFbFvA5DesJPkRhNwreILxWctFCGE6sgxkXfUqf8yz8UDuE8nweh5kicAAAAASUVORK5CYII="
                alt=""
              />
            </div>
            <div class="perSon_cardInformation">
              <div class="name">{{ item.name }}</div>
              <div class="cardNum">{{ item.cardNum }}</div>
            </div>
            <div class="perSon_ediot" @click="ediot(index)">编辑</div>
          </div>
        </van-cell>
      </div>

      <!-- 我的历史订单 -->

      <div class="myHistory">
        <div class="myHistory_text" @click="myHistory">我的历史订单 ></div>
      </div>
    </div>

    <!-- 底部预约模块 -->
    <div class="yuyueBottom_one">您正在前往第三方预约平台</div>
    <div class="yuyueBottom_two">
      <div class="num">
        共<span class="number">{{ selected.length }}</span
        >人
      </div>

      <div class="yuyueButton_box">
        <div class="yuyueButton" @click="yuyue">立即预约</div>
      </div>
    </div>

    <!-- 时间选择弹出框 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showPopup"
        @confirm="chooseTravelDate"
      />
    </van-popup>

    <!-- 入场时间选择弹出框 -->
    <van-popup v-model="show1" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="标题"
        show-toolbar
        :columns="sessionTimeArr"
        value-key="sessionTime"
        @confirm="sessionConfirm"
        @cancel="close"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import { mapGetters } from "vuex";
import {
  TravelDate,
  picpreFix,
  OrderDetail,
  getSession,
  Appointment,
  LoginOuter,
} from "../api/api";
export default {
  data() {
    return {
      museumInformation: "", //博物馆详情
      picpreFix,
      travelDate: "", //出行日期
      orderDetail: "", //预约详情
      show: false, //出行日期弹出框
      minDate: new Date(),
      maxDate: null,
      currentDate: new Date(),
      year: "",
      perSon: {}, //出行人信息
      sessionTimeArr: [], //到馆时间数组,
      sessionTime: "",
      show1: false, //到馆时间弹出框
      perSonNum: "", //当前剩余名额
      yuyueId: "", //预约成功后的id
    };
  },

  created() {

  
    console.log(this.minDate.getTime());
    this.maxDate = new Date(this.GetDateStr(2));
    
    this.museumId = this.$route.query.museumId;
    if(this.museumId){
        console.log(1)
        console.log(this.$route.query.museumId)
        this.id = this.$route.query.museumId;
    }else{
            console.log(2)
          this.id = this.$route.query.id;
           this.userId = this.$route.query.userId.replace(/\"/g, "");
             localStorage.setItem("userId", this.userId);
          this.login();
    }
    
    console.log(this.museumId);

    this.getOrderDetail();
  },
  computed: {
    ...mapGetters(["selected"]),
  },
  methods: {
    login() {
      var i = {
        appId: "ZSKJ_js8rwachLPIF5PtsFnl",
        openid: this.userId,
      };
      LoginOuter(i).then((res) => {
        console.log(res);
      });
    },
    //获取traveldate时间
    getTravelDate() {
      TravelDate({ museumId: this.museumId }).then((res) => {
        this.travelDate = res.data.data;
      });
    },
    //获取当前预约馆的详情
    getOrderDetail() {
      OrderDetail({ museumId: this.id }).then((res) => {
        this.orderDetail = res.data.data;
        console.log(this.orderDetail);
        this.museumId = res.data.data.id;
        this.getAllDate();
        this.getTravelDate();
        if (this.orderDetail.enableAppointmentThatDay) {
        }
      });
    },
    //弹出时间选择
    showPopup() {
      this.show = !this.show;
    },

    //时间换算
    getAllDate() {
      var datetime = new Date();
      var year = datetime.getFullYear();
      var month =
        datetime.getMonth() + 1 < 10
          ? "0" + (datetime.getMonth() + 1)
          : datetime.getMonth() + 1;
      var date =
        datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();

      console.log(year + "-" + month + "-" + date);
      this.currentDate = year + "-" + month + "-" + date;
      this.getSessionTime();
    },
    //添加游客
    addVisitor() {
      this.$router.push({
        path: "/addVisitor",
        query: { museumId: this.museumId },
      });
    },

    //编辑游客
    ediot(index) {
      this.$router.push({
        path: "/addVisitor",
        query: {
          index,
          museumId: this.museumId,
        },
      });
    },

    //我的历史订单
    myHistory() {
    //   localStorage.setItem("path", "/historyDetail");
      this.$router.push({ path: "/historyDetail" });
    },

    //是否选中
    checked(item, index) {
      this.$store.commit("CHECKED", { index, checked: !item.isSelected });
    },

    //删除人
    deletePerson(index) {
      this.$store.commit("DELETEPER", index);
    },

    //获取日期
    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      console.log(y + "-" + m + "-" + d);
      this.currentDate = y + "-" + m + "-" + d;
      return y + "-" + m + "-" + d;
    },

    //选择出行日期
    chooseTravelDate(e) {
      console.log(e);
      var y = e.getFullYear();
      var m =
        e.getMonth() + 1 < 10 ? "0" + (e.getMonth() + 1) : e.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = e.getDate() < 10 ? "0" + e.getDate() : e.getDate(); //获取当前几号，不足10补0

      this.currentDate = y + "-" + m + "-" + d;
      this.getSessionTime();
      this.show = !this.show;
    },
    //获取入馆时间
    getSessionTime() {
      getSession({
        museumId: this.museumId,
        travelDate: this.currentDate,
      }).then((res) => {
        let a = res.data.data;
        console.log(a);
        this.sessionTimeArr = a;
        console.log(this.sessionTimeArr);

        this.sessionTime = this.sessionTimeArr[0].sessionTime;
        this.perSonNum = this.sessionTimeArr[0].restNum;
      });
    },
    //打开到馆时间弹出框
    showSession() {
      this.show1 = !this.show1;
    },
    //到馆时间确认
    sessionConfirm(value) {
      console.log(value);
      this.sessionTime = value.sessionTime;
      this.perSonNum = value.restNum;
      this.show1 = !this.show1;
    },
    //到馆时间取消，关闭
    close() {
      this.show1 = !this.show1;
    },

    //立即预约
    yuyue() {
      if (!this.selected.length) {
        Toast("请选择出行人");
        return false;
      }
      if (!this.currentDate.length) {
        Toast("请选择出行日期");
        return false;
      }
      if (!this.sessionTime.length) {
        Toast("请选择到馆时间");
        return false;
      }
      if (this.perSonNum < this.selected.length) {
        Toast("剩余名额不够，请更换时间段");
        return false;
      }
      console.log(this.selected);
      Appointment({
        arrivalTime: this.sessionTime, //到馆时间
        museumId: this.museumId, //博物馆id
        reservationDate: this.currentDate, //出行日期
        identities: this.selected, //出行人信息
        hasZLB:true
      }).then((res) => {
        if (res.data.code == 200) {
          this.yuyueId = res.data.data.id;
          console.log(res);
          this.$router.push({
            path: "/success",
            query: { yuyueId: this.yuyueId },
          });
        } else {
          console.log(res);
          Toast(res.data.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  overflow: scroll;
  padding: 0 30px;
  box-sizing: border-box;
  padding-bottom: 300px;
}
.top_img {
  width: 100%;
  img {
    width: 100%;
  }
}
// 黄色背景模块
.museumInformation {
  margin-top: 30px;
  border-radius: 20px;
  padding: 20px;
  width: 100%;
  color: white;
  box-sizing: border-box;
  background-image: url(data:image/jpeg;base64,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);
  .museumName {
    font-size: 35px;
  }
  .museumIntroduce {
    font-size: 28px;
  }
}

// 时间选择模块
.timeChoose {
  width: 100%;
  box-sizing: border-box;
  margin-top: 30px;
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  .van-cell__left-icon,
  .van-cell__right-icon {
    line-height: 45px;
  }
  .travelDate_text {
    font-size: 26px;
    display: inline-block;
    padding: 20px 0;
    float: left;
  }
  .travelDate_text2 {
    font-size: 24px;
    display: inline-block;
    padding: 20px 0;
    float: right;
    color: #888;
  }
  .sessionTime_text {
    font-size: 26px;
    display: inline-block;
    padding: 20px 0;
    float: left;
  }
  .sessionTime_text2 {
    font-size: 24px;
    display: inline-block;
    padding: 20px 0;
    float: right;
    color: #888888;
  }
  .shengyu {
    font-size: 30px;
    display: inline-block;
    padding: 20px 0;
    color: #707376;
  }
}

// 添加游客模块
.addVisitors {
  width: 100%;
  background-color: white;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 20px;
  margin-top: 30px;

  .add_one {
    display: inline-block;
    font-size: 26px;
    padding: 20px 0;
  }
  .add {
    width: 30px;
    height: 30px;
    display: inline-block;
    float: right;

    box-sizing: border-box;
    img {
      padding: 25px 0;
      width: 100%;
      height: 100%;
    }
  }
}

// 选择游客
.chooseVisitors {
  width: 100%;
  background-color: white;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 30px;
  margin-top: 30px;

  // 选择标题
  .choose_title {
    font-size: 26px;
    margin-left: 20px;
  }
  // 选择事件点击
  .choose_person {
    display: flex;
    padding-left: 20rpx;

    .perSon_information {
      width: 100px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-left: 10px;
      padding: 10px;
      font-size: 26px;
      background-color: #f6f7f9;
      color: #707376;
      text-align: center;
      margin-top: 30px;
      border-radius: 10px;
      margin-right: 10px;
    }
    .selected {
      border: 1px solid !important;
      background-color: #ebf4ff !important;
      color: #3399ff !important;
    }
    .perSon_information2 {
      width: 100px;

      padding: 10px;
      font-size: 26px;
      background-color: #ebf4ff;
      color: #3399ff;
      text-align: center;
      margin-top: 30px;
      border-radius: 10px;

      margin-right: 10px;

      .chooseImg {
        width: 30px;
        height: 30px;
        display: inline-block;
        margin-right: 10px;

        position: relative;
        top: 5px;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  .van-cell__left-icon,
  .van-cell__right-icon {
    line-height: 48px;
  }
  //人员详细信息
  .perSon_Detail {
    width: 100%;
    display: flex;
    justify-items: center;
    align-items: center;

    .perSon_delete {
      width: 30px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .perSon_cardInformation {
      display: flex;
      flex-direction: column;
      margin-left: 30px;
      margin-right: 100px;
    }

    .perSon_ediot {
      align-self: center;

      color: #888888;
    }
  }
}

//我的历史订单模块
.myHistory {
  width: 100%;

  text-align: center;
  color: #8dc6d6;

  margin-top: 50px;

  font-size: 26px;
}

//底部预约模块
.yuyueBottom_one {
  width: 100%;
  height: 40px;
  text-align: center;
  background-color: #efefef;
  position: fixed;
  bottom: 130px;
  color: #707376;
  font-size: 26px;
}
.yuyueBottom_two {
  width: 100%;
  height: 130px;
  background-color: white;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .num {
    width: 50%;
    text-align: left;
    padding-left: 30px;
    font-size: 28px;
    .number {
      font-size: 50px;
      color: #ec624f;
    }
  }
  .yuyueButton_box {
    padding-right: 30px;
    color: white;
    .yuyueButton {
      width: 250px;
      height: 80px;

      background-color: #8dc6d6;
      border-radius: 50px;
      text-align: center;
      line-height: 80px;
      margin-right: -10px;
    }
  }
}
</style>

